import React, { useState, useEffect } from 'react';
import { FiCheckCircle, FiXCircle, FiEye, FiChevronDown, FiChevronUp, FiFilter, FiDownload } from 'react-icons/fi';
import './payroll-summary.css';
import { useParams } from "react-router-dom";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";
import ability from '../../config/defineAbility';
import { helpers } from '../../../helpers';
import cogoToast from "cogo-toast";
import { IconCancel, IconEyeDollar, IconMinus, IconPlus, IconUser, IconX, IconCheck } from '@tabler/icons-react'; // Optional icons
import { Loader } from 'react-overlay-loader';
import { useHistory } from "react-router-dom";

import { PERMS } from '../../config/perms'
const GeneratePayslips = (match) => {
  const history = useHistory();
  const incomingParams = useParams();
  const [trackId, setTrackId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // const [incomingParams, setincomingParams] =useState(match);
  const [payrollData, setPayrollData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [expandedRow, setExpandedRow] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [filters, setFilters] = useState({
    department: 'all',
    status: 'all'
  });
  const [commentText, setCommentText] = useState('');
  const [approvalWorkflow, setApprovalWorkflow] = useState([
    { id: 1, level: 1, approver: "John Doe", comment: "", approved: null },
    { id: 2, level: 2, approver: "Jane Smith", comment: "", approved: null },
  ]);
  
  // Track selection modal states
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [tracksList, setTracksList] = useState([]);
  const [loadingTracks, setLoadingTracks] = useState(false);

  // Sample data - in a real app this would come from an API
  useEffect(() => {

if(incomingParams['id']!=null)
{
  setTrackId(incomingParams['id']);
  getTrackDetails(incomingParams['id']);
}
else
{
  showTrackSelectionModel()
}


  
  }, []);

const showTrackSelectionModel = () => {
  setShowTrackModal(true);
  fetchTracksList();
}

// Fetch tracks list from API
const fetchTracksList = () => {
  setLoadingTracks(true);
  genericGet(ENDPOINTS.LIST_COMPLETE_PAYROLL_TRACK)
    .then((res) => {
      setLoadingTracks(false);
      if (res.status === 200) {
        if (res.data.status === SUCCESS_RESULT) {
          setTracksList(res.data.data || []);
        } else {
          cogoToast.error(res.data.message || 'Failed to fetch tracks');
        }
      } else {
        cogoToast.error('Failed to fetch tracks');
      }
    })
    .catch((err) => {
      setLoadingTracks(false);
      console.error('Error fetching tracks:', err);
      cogoToast.error('Error fetching tracks');
    });
}

// Handle track selection
const handleTrackSelection = (track) => {
  setTrackId(track.id);
  setSelectedTrack(track);
  setShowTrackModal(false);
  getTrackDetails(track.id);
}

const getEmployeeStaffId = (employee) =>
  employee?.details?.staff_details?.id;

const buildPayslipRequestData = (employee) => ({
  track_id: employee?.track_id ?? selectedTrack?.id ?? trackId,
  staff_id: getEmployeeStaffId(employee),
  month: employee?.month ?? selectedTrack?.month,
  year: employee?.year ?? selectedTrack?.year,
});

  const getTrackDetails = (id) => {
    if (!id) return;
    setIsLoading(true);

    genericPost(ENDPOINTS.TRACK_PAYROLL_APPROVAL_DETAILS, { track_id: id })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            setPayrollData(responseData);
            setFilteredData(responseData);
            if (responseData && responseData.length > 0) {
              const uniqueDepartments = [
                ...new Set(responseData.map(item => item.department))
              ];
              setDepartments(uniqueDepartments);
              setSelectedTrack((prev) => ({
                ...prev,
                id,
                name: responseData[0]?.track_name ?? prev?.name,
                month: responseData[0]?.month ?? prev?.month,
                year: responseData[0]?.year ?? prev?.year,
              }));
            }
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          alert(res.status)
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }
  // Filter data based on department and status
  useEffect(() => {
    let result = payrollData;

    if (filters.department !== 'all') {
      result = result.filter(item => item.department === filters.department);
    }

    if (filters.status !== 'all') {
      result = result.filter(item => item.payroll_status === filters.payroll_status);
    }

    setFilteredData(result);

    // Update select all state when filtering
    const allSelected = result.length > 0 && result.every(emp => selectedEmployees.includes(emp.staff_code));
    setSelectAll(allSelected);
  }, [filters, payrollData, selectedEmployees]);

  // Handle select all checkbox
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = filteredData.map(emp => emp.staff_code);
      setSelectedEmployees(allIds);
      setSelectAll(true);
    } else {
      setSelectedEmployees([]);
      setSelectAll(false);
    }
  };

  // Handle individual employee checkbox
  const handleEmployeeSelect = (id) => {
    if (selectedEmployees.includes(id)) {
      setSelectedEmployees(selectedEmployees.filter(empId => empId !== id));
      setSelectAll(false);
    } else {
      setSelectedEmployees([...selectedEmployees, id]);

      // If all employees are now selected, update selectAll
      if (selectedEmployees.length + 1 === filteredData.length) {
        setSelectAll(true);
      }
    }
  };

  // Sort data
  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    setFilteredData(sortedData);
    setSortConfig({ key, direction });
  };

  // Handle approval action
  const handleApproval = (id, approved) => {
    const updatedData = payrollData.map(item => {
      if (item.id === id) {
        // Find the current user's role (in a real app, this would come from authentication)
        const currentRole = 'Finance'; // Example role

        const updatedWorkflow = item.approvalWorkflow.map(step => {
          if (step.role_name === currentRole) {
            return {
              ...step,
              approved,
              date: new Date().toISOString().split('T')[0],
              comment: commentText
            };
          }
          return step;
        });

        // Determine overall status based on approvals
        const allApproved = updatedWorkflow.every(step => step.approved === true);
        const anyRejected = updatedWorkflow.some(step => step.approved === false);

        let newStatus = item.status;
        if (allApproved) newStatus = 'approved';
        else if (anyRejected) newStatus = 'rejected';
        else newStatus = 'pending';

        return {
          ...item,
          approvalWorkflow: updatedWorkflow,
          status: newStatus
        };
      }
      return item;
    });

    setPayrollData(updatedData);
    setCommentText('');
  };

  // Toggle row expansion for details
  const toggleExpand = (id) => {
    if (expandedRow === id) {
      setExpandedRow(null);
    } else {
      setExpandedRow(id);
    }
  };

  // Get status badge class
  const getStatusClass = (status) => {
    switch (status) {
      case 'approved': return 'status-badge approved';
      case 'rejected': return 'status-badge rejected';
      default: return 'status-badge pending';
    }
  };

  // Calculate percentage change from last month
  const calculateChange = (current, previous) => {
    if (previous === 0) return 0;
    return ((current - previous) / previous * 100).toFixed(1);
  };
  const handleApprovalAction = (index, employee, action, approval_type) => {
    // 'track_id' => 'required|exists:hrm_payroll_tracks,id',
    //           'action'=>'required|in:"10001,10002',
    //           "approval_type"=>'required|in:"individual","all"',
    //           'comment'=>'string',
    //           "assignment_id"=>'string|exists:workflow_level_assignments,id',
    if (console.confirm("Are you sure to " + (action == "10001" ? "Approve" : "Reject") + "  this Payroll ?")) {
      setIsLoading(true);
      let postData = {
        "track_id": employee.track_id,
        "action": action,
        "approval_type": approval_type,
        "remarks": approvalWorkflow[index].comment,
        "assignment_id": employee?.assignment_id??"",
      }

      genericPost(ENDPOINTS.TRACK_PAYROLL_APPROVAL, postData)
        .then((res) => {
          setIsLoading(false);
          if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
              let responseData = res.data.data;
              // alert((JSON.stringify(responseData)));
              setPayrollData(responseData);
              if (responseData && responseData.length > 0) {
                const uniqueDepartments = [
                  ...new Set(responseData.map(item => item.department))
                ];
                setDepartments(uniqueDepartments);
              }
              //  setFilteredData(responseData);
              // setRowData(responseData);
            } else {
              cogoToast.error(res.data.message, {});
            }
          } else {
            alert(res.status)
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  }
  const handleCommentChange = (index, value) => {
    const updated = [...approvalWorkflow];
    updated[index].comment = value;
    setApprovalWorkflow(updated);
  };
  return (
    <div className="payroll-summary-container">
      <div className="payroll-header">
        <h1>Generate Payslips- {payrollData.length > 0 ? payrollData[0].track_name : ""} </h1>
        <div className="header-actions">
          <button className="btn btn-secondary">
            <FiFilter /> Filter
          </button>
          <button className="btn btn-primary">
            <FiDownload /> Export
          </button>
        </div>
      </div>
      <center> <Loader loading={isLoading} /></center>
      <div className="filters">
        <div className="filter-group">
          <label>Department:</label>
          <select
            value={filters.department}
            onChange={(e) => setFilters({ ...filters, department: e.target.value })}
          >
            <option value="all">All Departments</option>
            {departments.map(dep => (
              <option key={dep} value={dep}>
                {dep}
              </option>
            ))}
            {/* <option value="Engineering">Engineering</option>
            <option value="Marketing">Marketing</option>
            <option value="Finance">Finance</option>
            <option value="HR">HR</option> */}
          </select>
        </div>

        

       
      </div>


      <div className="payroll-table-container">
        {/* {JSON.stringify(payrollData)} */}
        <table className="payroll-table">
          <thead>
            <tr>
             
              <th className="counter-column">#</th>
              <th>Staff</th>
              {/* <th onClick={() => handleSort('staff_code')}>Staff ID</th> */}
              <th onClick={() => handleSort('department')}>Department</th>
              <th onClick={() => handleSort('office_name')}>Branch</th>
              <th>Salary</th>
              <th>Allowc & Bonus</th>
              {/* <th>Bonus</th> */}
              {/* <th>Adj.Earnings</th> */}
              <th>Taxes</th>
              {/* <th>Adj.Deductions</th> */}
              <th onClick={() => handleSort('net_pay')}>Net Pay</th>
        
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((employee, index) => (
              <React.Fragment key={employee?.id ?? index}>
                <tr className={expandedRow === employee?.id ? "expanded" : ""}>
                

                  <td className="counter-column">{index + 1}</td>
                  <td className="employee-info">
                    <div className="employee-name">{employee.staff_name}</div>
                    <div className="employee-id">{employee.staff_code} | {employee.role_name}</div>
                  </td>
                
                  <td>{employee?.department ?? ""}</td>
                  <td>{employee?.office_name ?? ""}</td>
                  <td>${employee?.basic_salary ?? ""}</td>
                  <td>${(employee?.total_allowances ?? 0) + (employee?.total_bonus ?? 0)}</td>
                  {/* <td>${employee?.total_bonus ?? ""}</td> */}
                  {/* <td>${employee?.total_adjusted_earning ?? ""}</td> */}
                  <td>${employee?.total_taxes ?? ""}</td>
                  {/* <td>${employee?.total_adjusted_deduction ?? ""}</td> */}
                  <td>${employee?.net_pay ?? ""}</td>
                  
              


                  <td>
                    <button className="btn btn-primary" onClick={() => {
                      const payslipData = buildPayslipRequestData(employee);
                      if (!payslipData.staff_id) {
                        cogoToast.error("Staff ID not found for this employee");
                        return;
                      }
                      if (!payslipData.month || !payslipData.year) {
                        cogoToast.error("Payroll month/year not available for this track");
                        return;
                      }
                      history.push({
                        pathname: LOCAL_PATHS.PAYSLIP,
                        state: { data: payslipData },
                      });
                    }}>
                      <FiDownload /> Download Payslip
                    </button>
                  </td>
                </tr>

              
              </React.Fragment>
            ))}
          </tbody>

        </table>
      </div>

      <div className="payroll-footer">
       
        <div className="summary">
          <div className="summary-item">
            <span>Total Payroll:</span>
            <span>${filteredData.reduce((sum, emp) => sum + emp.net_pay ?? 0, 0).toLocaleString()}</span>
          </div>
         
        </div>
      </div>

      {/* Track Selection Modal */}
      {showTrackModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
              borderBottom: '1px solid #dee2e6',
              paddingBottom: '10px'
            }}>
              <h3 style={{ margin: 0, color: '#495057' }}>Select Payroll Track</h3>
              <button
                onClick={() => setShowTrackModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                ×
              </button>
            </div>
            
            <div className="modal-body">
              {loadingTracks ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p style={{ marginTop: '10px' }}>Loading tracks...</p>
                </div>
              ) : tracksList.length > 0 ? (
                <div className="tracks-list">
                  {tracksList.map((track, index) => (
                    <div
                      key={track.id}
                      className="track-item"
                      onClick={() => handleTrackSelection(track)}
                      style={{
                        padding: '15px',
                        border: '1px solid #dee2e6',
                        borderRadius: '6px',
                        marginBottom: '10px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        backgroundColor: '#f8f9fa'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e9ecef';
                        e.target.style.borderColor = '#007bff';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.borderColor = '#dee2e6';
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <h5 style={{ margin: '0 0 5px 0', color: '#495057' }}>{track.name}</h5>
                          <p style={{ margin: '0', color: '#6c757d', fontSize: '14px' }}>
                            {new Date(track.created_at).toLocaleDateString()} - Month: {track.month}, Year: {track.year}
                          </p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <span style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            backgroundColor: track.status === 10000 ? '#d4edda' : '#f8d7da',
                            color: track.status === 10000 ? '#155724' : '#721c24'
                          }}>
                            {track.status === 10000 ? 'Active' : 'Inactive'}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p style={{ color: '#6c757d' }}>No tracks available</p>
                </div>
              )}
            </div>
            
            <div className="modal-footer" style={{
              borderTop: '1px solid #dee2e6',
              paddingTop: '15px',
              textAlign: 'right'
            }}>
              <button
                onClick={() => setShowTrackModal(false)}
                className="btn btn-secondary"
                style={{ marginRight: '10px' }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneratePayslips;